var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncidentReport = function SvgIncidentReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "incident_report_svg2__a",
    x1: -12.2,
    x2: 154.8,
    y1: 173.5,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__b",
    x1: 21.1,
    x2: 188.1,
    y1: 208.4,
    y2: 49.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__c",
    x1: 7,
    x2: 174,
    y1: 193.6,
    y2: 34.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__d",
    x1: -20.8,
    x2: 146.2,
    y1: 164.4,
    y2: 5.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__e",
    x1: -12,
    x2: 155,
    y1: 173.7,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__f",
    x1: 12.5,
    x2: 179.5,
    y1: 199.4,
    y2: 40.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__g",
    x1: 21.3,
    x2: 188.3,
    y1: 208.7,
    y2: 49.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__h",
    x1: -1.3,
    x2: 165.7,
    y1: 184.9,
    y2: 25.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__i",
    x1: 5.3,
    x2: 172.3,
    y1: 191.9,
    y2: 32.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__j",
    x1: 8,
    x2: 175,
    y1: 194.7,
    y2: 35.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__k",
    x1: 32,
    x2: 199,
    y1: 219.8,
    y2: 60.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__l",
    x1: 38.6,
    x2: 205.6,
    y1: 226.8,
    y2: 67.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#incident_report_svg2__a",
    id: "incident_report_svg2__m",
    x1: 41.3,
    x2: 208.3,
    y1: 229.7,
    y2: 70.7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 50.6c-2.1-3.7-6.7-5-10.4-3-1.2.7-2.3 1.7-3 3L44.4 94.7c-1.4 2.5-1.4 5.6 0 8.1 1.4 2.4 3.9 3.9 6.7 3.9h51.1c2.8 0 5.3-1.5 6.7-3.9 1.4-2.5 1.4-5.6 0-8.1zm19.7 48.8c-.2.3-.5.6-.9.6H51.1q-.6 0-.9-.6c-.3-.4-.3-1 0-1.4l25.6-44.1c.2-.3.5-.6.9-.6s.8.2.9.6L103.1 98c.3.4.3 1 0 1.4",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4 117.3c-2.1-3.7-6.7-5-10.4-3-1.2.7-2.3 1.7-3 3l-25.6 44.1c-1.4 2.5-1.4 5.6 0 8.1 1.4 2.4 3.9 3.9 6.7 3.9h51.1c2.8 0 5.3-1.5 6.7-3.9 1.4-2.5 1.4-5.6 0-8.1zm19.7 48.8c-.2.3-.5.6-.9.6H51.1q-.6 0-.9-.6c-.3-.4-.3-1 0-1.4l25.6-44.1c.2-.3.5-.6.9-.6s.8.2.9.6l25.5 44.1c.3.4.3 1 0 1.4",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.3 10H130c0-5.5-4.5-10-10-10H80c-5.5 0-10 4.5-10 10H26.7c-5.5 0-10 4.5-10 10v170c0 5.5 4.5 10 10 10h146.7c5.5 0 10-4.5 10-10V20c0-5.5-4.5-10-10-10Zm-10 146.7h-16.7c-3.7 0-6.7 3-6.7 6.7v16.7H36.7V30h33.9c1.4 4 5.2 6.6 9.4 6.7h40c4.2 0 8-2.7 9.4-6.7h33.9zm-4.7 6.6-12 12v-12zM76.7 10c0-1.8 1.5-3.3 3.3-3.3h40c1.8 0 3.3 1.5 3.3 3.3v16.7c0 1.8-1.5 3.3-3.3 3.3H80c-1.8 0-3.3-1.5-3.3-3.3zm100 180c0 1.8-1.5 3.3-3.3 3.3H26.7c-1.8 0-3.3-1.5-3.3-3.3V20c0-1.8 1.5-3.3 3.3-3.3H70v6.7H36.7c-3.7 0-6.7 3-6.7 6.7v150c0 3.7 3 6.7 6.7 6.7H142c1.8 0 3.5-.7 4.7-2l21.4-21.4c1.2-1.3 1.9-2.9 2-4.7V30c0-3.7-3-6.7-6.7-6.7h-33.3v-6.7h43.3c1.8 0 3.3 1.5 3.3 3.3v170Z",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7 63.3c-1.8 0-3.3 1.5-3.3 3.3v10c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3v-10c0-1.8-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7 85.3c-1.8 0-3.3 1.5-3.3 3.3V90c0 1.8 1.5 3.3 3.3 3.3S80 91.8 80 90v-1.4c0-1.8-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7 130c-1.8 0-3.3 1.5-3.3 3.3v10c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3v-10c0-1.8-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7 152c-1.8 0-3.3 1.5-3.3 3.3v1.4c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3v-1.4c0-1.8-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7 53.3c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3H150c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3z",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 66.7h-33.3c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3H150c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7 86.7h16.7c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3h-16.7c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 120h-33.3c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3H150c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 133.3h-33.3c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3H150c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3",
    style: {
      fill: "url(#incident_report_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3 146.7h-16.7c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3h16.7c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3",
    style: {
      strokeWidth: 0,
      fill: "url(#incident_report_svg2__m)"
    }
  }));
};
export default SvgIncidentReport;